// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSwapOutlinedSvg from "@fishx/icons-svg/es/asn/PSwapOutlined";
import FishxIcon from '../components/FishxIcon';

var PSwapOutlined = function PSwapOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSwapOutlinedSvg
  }));
};

PSwapOutlined.displayName = 'PSwapOutlined';
export default React.forwardRef(PSwapOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSwapOutlined.js
// module id = 3670
// module chunks = 0